import {
  ListBoardDeviceAssociations,
  ListBoardDeviceAssociationsVariables
} from './__generated__/ListBoardDeviceAssociations'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

export const QUERY = gql`
  query ListBoardDeviceAssociations($input: BoardDeviceAssociationInput!) {
    listBoardDeviceAssociations(input: $input) {
      boardDeviceAssociations {
        id
        boardDeviceAssociationCreated
        deviceId
        deviceCreated
        pairingCode
        firmwareVersion
        boardId
        boardTitle
        boardCreated
        boardDeleted
        personId
        personFirstName
        personLastName
        accountId
        accountEmailAddress
        productApplicationId
        productApplicationCreated
        plusRenewalDate
        productPricingId
        productPricingRecurringFrequency
        ssid
        online
        lastMessage
        messagesInPastDay
        messagesInPastSevenDays
        messagesInPastThirtyDays
        messagesAllTime
        deviceLastSeen
        yoctoStatus
        deviceModelId
        deviceModelTitle
        lastIndexed
        memberEmailAddresses
        enabledChannels
        channels
        internalBoard
        hubspotDealId
        memberIds
        osVersionName
        transitionStrategy
        transitionStepSize
        boiSerialNumber
        stripeSubscriptionId
        stripeCurrentPeriodEnd
        stripeCurrentPeriodStart
        stripeStatus
        stripeInterval
        stripeSubscriptionCreated
        stripeStartDate
        stripeCanceledAt
        stripeCancelAt
        stripeEndedAt
        stripeTrialStart
        stripeTrialEnd
        stripeBillingCycleAnchor
      }
      pagination {
        page
        total
        perPage
      }
    }
  }
`

export const useBoardDeviceAssociations = (variables: ListBoardDeviceAssociationsVariables) =>
  useQuery<ListBoardDeviceAssociations, ListBoardDeviceAssociationsVariables>(QUERY, {
    variables
  })
